/** @category Version */
// Note: This file is autogenerated using "resources/gen-version.js" script and
// automatically updated by "npm version" command.

/** A string containing the version of the GraphQL.js library */
export const version = '16.14.2';
/** An object containing the components of the GraphQL.js version string */

export const versionInfo = Object.freeze({
  major: 16,
  minor: 14,
  patch: 2,
  preReleaseTag: null,
});
